import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shortid from 'shortid';

import CardContainer from './CardContainer.jsx';

import { sendImpressionEventBatch } from '../../../../../methods';

class CardList extends PureComponent {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired,
        cardProportions: PropTypes.object.isRequired,
        cards: PropTypes.array.isRequired,
        containerClass: PropTypes.string.isRequired,
        contentLoading: PropTypes.bool.isRequired,
        initialContentLoaded: PropTypes.bool.isRequired,
        sliderDisabled: PropTypes.bool.isRequired,
        unstable: PropTypes.bool.isRequired,
        width: PropTypes.number.isRequired
    }

    componentDidMount() {
        $(window).scroll(this.collectImpressionEvents);
    }

    componentDidUpdate() {
        if (!this.props.contentLoading && this._impressionEvents.length) {
            this.sendImpressionEvents(this._impressionEvents);
            this._impressionEvents = [];
        }
    }

    _impressionEvents = []

    addImpressionEventToBatch = impressionEvent => {
        this._impressionEvents = [...this._impressionEvents, impressionEvent];
    }

    collectImpressionEvents = () => {
        clearTimeout($.data(this, 'scrollTimer'));
        $.data(this, 'scrollTimer', setTimeout(() => {
            if (this._impressionEvents.length) {
                this.sendImpressionEvents(this._impressionEvents);
                this._impressionEvents = [];
            }
        }, 1500));
    }

    sendImpressionEvents = () => {
        sendImpressionEventBatch(this.props.apiUrl, this._impressionEvents);
    }

    renderCardContainer = card => (
        <CardContainer
            key={shortid.generate()}
            addImpressionEventToBatch={this.addImpressionEventToBatch}
            card={card}
            cardId={card.id}
            cardProportions={this.props.cardProportions}
            containerClass={this.props.containerClass}
            contentLoading={this.props.contentLoading}
            initialContentLoaded={this.props.initialContentLoaded}
            sliderDisabled={this.props.sliderDisabled}
            unstable={this.props.unstable}
            width={this.props.width}
        />
    )

    render() {
        return (
            <div>
                {this.props.cards.map(this.renderCardContainer)}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    apiUrl: state.config.apiUrl,
    cards: state.searchResults.data,
    initialContentLoaded: state.initialContentLoaded,
    unstable: state.mapState.unstable
});

export default connect(mapStateToProps)(CardList);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/CardList.jsx